export default {
  lang: 'zh-CN',
  dir: 'ltr',
  common: {
    ok: '确定',
    cancel: '取消',
    key_backspace: '退格',
    key_del: '删除',
    key_down: '下',
    key_up: '上',
    more_opts: '更多选项',
    url: 'URL',
    width: '宽度',
    height: '高度'
  },
  misc: {
    powered_by: 'Powered by'
  },
  ui: {
    toggle_stroke_tools: '显示/隐藏更式边线工具',
    palette_info: '点击更改填充颜色，按住Shift键单击更改线条颜色',
    zoom_level: '更改缩放级别',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: '元素ID',
    fill_color: '更改填充颜色',
    stroke_color: '线条的颜色变化',
    stroke_style: '更改线条样式',
    stroke_width: '更改线条宽度',
    pos_x: '更改X坐标',
    pos_y: '更改Y坐标',
    linecap_butt: '顶端样式: 齐平',
    linecap_round: '顶端样式: 圆滑',
    linecap_square: '顶端样式: 方块',
    linejoin_bevel: '连接处: 削平',
    linejoin_miter: '连接处: 直角',
    linejoin_round: '连接处: 圆角',
    angle: '更改旋转角度',
    blur: '更改高斯模糊值',
    opacity: '更改所选条目的不透明度',
    circle_cx: '改变圆的中心X坐标',
    circle_cy: '改变圆的中心Y坐标',
    circle_r: '改变圆的半径',
    ellipse_cx: '改变椭圆的中心X坐标',
    ellipse_cy: '改变椭圆的中心Y坐标',
    ellipse_rx: '改变椭圆的x半径',
    ellipse_ry: '改变椭圆的y半径',
    line_x1: '更改直线起点的x坐标',
    line_x2: '更改直线终点的x坐标',
    line_y1: '更改直线起点的y坐标',
    line_y2: '更改直线终点的y坐标',
    rect_height: '更改矩形的高度',
    rect_width: '更改矩形的宽度',
    corner_radius: '角半径：',
    image_width: '更改图像的宽度',
    image_height: '更改图像的高度',
    image_url: '更改网址',
    node_x: '更改节点的X坐标',
    node_y: '更改节点的Y坐标',
    seg_type: '修改线段类型',
    straight_segments: '直线',
    curve_segments: '曲线',
    text_contents: '更改文本内容',
    font_family_label: 'Font:',
    font_family: '更改字体样式',
    font_size: '更改字体大小',
    bold: '粗体',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: '斜体',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: '主菜单',
    bkgnd_color_opac: '更改背景颜色/不透明',
    connector_no_arrow: '无箭头',
    fitToContent: '适应内容',
    fit_to_all: '适应于所有的内容',
    fit_to_canvas: '适应画布',
    fit_to_layer_content: '适应层内容',
    fit_to_sel: '适应选中内容',
    align_relative_to: '相对对齐 ...',
    relativeTo: '相对于:',
    page: '网页',
    largest_object: '最大对象',
    selected_objects: '选中的对象',
    smallest_object: '最小的对象',
    new_doc: '新文档',
    open_doc: '打开文档',
    export_img: '导出',
    save_doc: '保存图像',
    import_doc: '导入SVG',
    align_to_page: '对齐元素到页面',
    align_bottom: '底部对齐',
    align_center: '居中对齐',
    align_left: '左对齐',
    align_middle: '水平居中对齐',
    align_right: '右对齐',
    align_top: '顶端对齐',
    mode_select: '选择工具',
    mode_fhpath: '铅笔工具',
    mode_line: '线工具',
    mode_rect: '矩形',
    mode_square: '正方形',
    mode_fhrect: '自由矩形',
    mode_ellipse: '椭圆',
    mode_circle: '圆形',
    mode_fhellipse: '自由椭圆',
    mode_path: '路径',
    mode_text: '文字工具',
    mode_image: '图像工具',
    mode_zoom: '缩放工具',
    no_embed: '注意: 根据SVG图像的存储位置，内嵌的位图可能无法显示!',
    undo: '撤消',
    redo: '重做',
    tool_source: '编辑源',
    wireframe_mode: '线条模式',
    clone: '克隆元素',
    del: '删除元素',
    group_elements: '组合元素',
    make_link: '创建超链接',
    set_link_url: '设置链接URL (设置为空以删除)',
    to_path: '转换为路径',
    reorient_path: '调整路径',
    ungroup: '取消组合元素',
    docprops: '文档属性',
    editor_homepage: 'SVG-Edit 主页',
    move_bottom: '移至底部',
    move_top: '移至顶部',
    node_clone: '复制节点',
    node_delete: '删除节点',
    node_link: '连接控制点',
    add_subpath: '添加子路径',
    openclose_path: '打开/关闭 子路径',
    source_save: '保存',
    cut: '剪切',
    copy: '复制',
    paste: '粘贴',
    paste_in_place: '粘贴到原位置',
    delete: '删除',
    group: '组合',
    move_front: '移至顶部',
    move_up: '向上移动',
    move_down: '向下移动',
    move_back: '移至底部',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: '图层',
    layers: '图层',
    del: '删除图层',
    move_down: '向下移动图层',
    new: '新建图层',
    rename: '重命名图层',
    move_up: '向上移动图层',
    dupe: '复制图层',
    merge_down: '向下合并',
    merge_all: '全部合并',
    move_elems_to: '移动元素至:',
    move_selected: '移动元素至另一个图层'
  },
  config: {
    image_props: '图像属性',
    doc_title: '标题',
    doc_dims: '画布大小',
    included_images: '包含图像',
    image_opt_embed: '嵌入数据 (本地文件)',
    image_opt_ref: '使用文件引用',
    editor_prefs: '编辑器首选项',
    language: '语言',
    background: '编辑器背景',
    editor_img_url: '图像 URL',
    editor_bg_note: '注意: 背景不会保存在图像中.',
    select_predefined: '选择预定义:',
    units_and_rulers: '单位 & 标尺',
    show_rulers: '显示标尺',
    base_unit: '基本单位:',
    grid: '网格',
    snapping_onoff: '吸附开/关',
    snapping_stepsize: '吸附步长:',
    grid_color: '网格颜色',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: '无效的参数',
    noContentToFitTo: '无可适应的内容',
    dupeLayerName: '已存在同名的图层!',
    enterUniqueLayerName: '请输入一个唯一的图层名称',
    enterNewLayerName: '请输入新的图层名称',
    layerHasThatName: '图层已经采用了该名称',
    QmoveElemsToLayer: "您确定移动所选元素到图层'%s'吗?",
    QwantToClear: '您希望清除当前绘制的所有图形吗?\n该操作将无法撤消!',
    QwantToOpen: '您希望打开一个新文档吗?\n该操作将无法撤消!',
    QerrorsRevertToSource: 'SVG文件解析错误.\n是否还原到最初的SVG文件?',
    QignoreSourceChanges: '忽略对SVG文件所作的更改么?',
    featNotSupported: '不支持该功能',
    enterNewImgURL: '请输入新图像的URLL',
    defsFailOnSave: '注意: 由于您所使用的浏览器存在缺陷, 该图像无法正确显示 (不支持渐变或相关元素). 修复该缺陷后可正确显示.',
    loadingImage: '正在加载图像, 请稍候...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: '同时注意以下几点: ',
    unsavedChanges: '存在未保存的修改.',
    enterNewLinkURL: '输入新建链接的URL地址',
    errorLoadingSVG: '错误: 无法加载SVG数据',
    URLLoadFail: '无法从URL中加载',
    retrieving: '检索 \'%s\'...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
